import {useQuery} from "react-query";
import {RoleMemberSearchRequest} from "../../models/user";
import roleMemberService from "../../services/RoleMemberService";

export default function useRoleMembers(request: RoleMemberSearchRequest) {
   return useQuery(['role-members', request], () => roleMemberService.search(request));
}